import axios from "../shared/axios";
import store from '../store/index';
const jwtInterceptor = axios

jwtInterceptor.interceptors.request.use((config) => {
  const authData = store.getters["auth/getAuthData"];
  config.headers.common["Authorization"] = 'Bearer ' + authData.token;
  return config;
});
export default jwtInterceptor;